/** Height in pixels used for virtualized rendering of all plate map note part plugins. */
export const PLATE_MAP_PLUGIN_VIRTUALIZED_HEIGHT = 660;
